// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"8567c51f","238":"a1917536","239":"395b9036","362":"b6037421","413":"2998369f","472":"f607952e","550":"7fb4439d","650":"e5c30d59","687":"0769083d","771":"c8c227ed"}[chunkId] + ".chunk.js";
};